export type ScenarioKey =
  // | "vegetable_shop"
  | "fruit_shop"
  | "library"
  | "visiting_friend"
  | "doctor_clinic";

export type DifficultyKey = "easy" | "medium" | "hard";

export interface AppConfig {
  scenario: ScenarioKey;
  learnerRole: string;
  difficulty: DifficultyKey;
}

export const SCENARIO_LABELS: Record<ScenarioKey, string> = {
  // vegetable_shop: "காய்கறி கடை (Vegetable Shop)",
  fruit_shop: "பழக் கடை (Fruit Shop)",
  library: "நூலகம் (Library)",
  visiting_friend: "நண்பர் வீடு (Visiting a Friend)",
  doctor_clinic: "மருத்துவமனை (Doctor Clinic)",
};

/** Gemini Live `prebuiltVoiceConfig.voiceName` per scenario (see Google GenAI Live voice list). */
export const SCENARIO_LIVE_VOICE_NAME: Record<ScenarioKey, string> = {
  // vegetable_shop: "Kore",
  fruit_shop: "Fenrir",
  // Use a female voice for these scenarios
  library: "Erinome",
  visiting_friend: "Erinome",
  doctor_clinic: "Erinome",
};

/** Learner role (Tamil) auto-mapped from scenario: customer, reader, guest, patient */
export const SCENARIO_LEARNER_ROLE: Record<ScenarioKey, string> = {
  // vegetable_shop: "வாடிக்கையாளர்",
  fruit_shop: "வாடிக்கையாளர்",
  library: "வாசகர்",
  visiting_friend: "விருந்தினர்",
  doctor_clinic: "நோயாளி",
};

export function getLearnerRoleForScenario(scenario: ScenarioKey): string {
  return SCENARIO_LEARNER_ROLE[scenario];
}

export const SCENARIO_OPTIONS: ScenarioKey[] = [
  // "vegetable_shop",
  "fruit_shop",
  "library",
  "visiting_friend",
  "doctor_clinic",
];

export const DIFFICULTY_OPTIONS: { value: DifficultyKey; label: string }[] = [
  { value: "easy", label: "Easy" },
  { value: "medium", label: "Medium" },
  { value: "hard", label: "Hard" },
];
